/**
 * Steps that end the flow. Each is a static page and a registered screen, but
 * none sits in the step order: the flow reaches them only by an explicit
 * route (a server gate, or a minor's wrap-up), so stepping forward from any
 * other step never lands on one, and they offer no way on.
 */
export const SIGNUP_TERMINAL_STEPS = ['under-age', 'minor-unsupported', 'registered'] as const;

export type SignupTerminalStepId = (typeof SIGNUP_TERMINAL_STEPS)[number];
